<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/d1KK45/tc-custom/9781772120547.jpg?1737756130940" alt="This image is the cover for the book Canadian Girl in South Africa, Wayfarer"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Canadian Girl in South Africa, Wayfarer
      </h1>
      <p class="bookDescription body article font2">
        <b>A Canadian woman shares her story of traveling to South Africa to teach Boer children in concentration camps following the South African War.</b><br/><br/>As the South African War reached its grueling end in 1902, colonial interests at the highest levels of the British Empire hand-picked teachers from across the Commonwealth to teach the thousands of Boer children living in concentration camps. Highly educated, hard working, and often opinionated, E. Maud Graham joined the Canadian contingent of forty teachers. Her eyewitness account reveals the complexity of relations and tensions at a controversial period in the histories of both Britain and South Africa. Graham presents a lively historical travel memoir, and the editors have provided rich political and historical context to her narrative in the Introduction and generous annotations. This is a rare primary source for experts in Colonial Studies, Women’s Studies, and Canadian, South African, and British Imperial History. Readers with an interest in the South African War will be intrigued by Graham’s observations on South African society at the end of the Victorian era.<br/><br/><b>“A fascinating perspective on the country. . . . Graham’s account will help others understand how the British and English-speaking Canadians in South Africa perceived Boers and native southern Africans at the turn of the twentieth century, and her descriptions reveal details about everyday life in South Africa at an important moment of transition.... Graham’s book represents the perspective of a well-embedded outsider reporting to far-removed readers, rather than that of a female teacher involved in international or imperial education.” —Benjamin Bryce, <i>Historical Studies in Education</i></b><br/><br/><b>“Recommended for those who wish to learn more about South African history and early race relations or tensions. Graham’s opinionated writing will amuse and interest those researching women’s studies.” —Amy L. Crofford, <i>African Studies Quarterly</i>, Volume 16</b>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        E. Maud Graham, Michael Dawson, Catherine Gidney, Susanne M. Klausen
      </h2>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The University of Alberta Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?6977f7f6